import React, {PureComponent} from 'react'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import PropTypes from 'prop-types'

import { cartSelectors } from 'redux/selectors'
import paywallsActions from 'redux/actions/paywallsActions'
import upgradeSourceTypes from 'helpers/enums/metrics/upgradeSourceTypes'
import NotEnoughSpaceConfirm from 'views/paywalls/confirms/not_enough_space_confirm'

class NotEnoughSpaceConfirmContainer extends PureComponent {
	intercomIsEnabled = () => {
		const body = document.getElementsByTagName('body')[0]
		const classNames = body.getAttribute('class') || ''
		const bodyClasses = classNames.split(' ')
		const intercomIndex = bodyClasses.indexOf('hide-intercom')
		return intercomIndex === -1
	}

	handleConfirmSelected = () => {
		this.props.actions.confirmUpgrade(this.intercomIsEnabled(), this.props.upgradeSource)
	}

	render() {
		return (
			<NotEnoughSpaceConfirm
				handleConfirmSelected={this.handleConfirmSelected}
				handleCloseConfirm={this.props.actions.closeConfirm}
				handleNotNowSelected={this.props.actions.closeConfirm}
				maxStorage={this.props.maxStorage}
				offerMessage={this.props.offerMessage}
				shouldShowNewTitle={this.props.shouldShowNewTitle}
				shouldOfferUpgrade={this.props.shouldOfferUpgrade}
			/>
		)
	}
}

NotEnoughSpaceConfirmContainer.propTypes = {
	maxStorage: PropTypes.string.isRequired,
	shouldOfferUpgrade: PropTypes.bool.isRequired,
	actions: PropTypes.shape({
		closeConfirm: PropTypes.func.isRequired,
		confirmUpgrade: PropTypes.func.isRequired,
	}),
	intercomIO: PropTypes.bool,
	shouldShowNewTitle: PropTypes.bool,
	offerMessage: PropTypes.string,
	upgradeSource: PropTypes.oneOf(
		Object.values(upgradeSourceTypes)
	).isRequired,
}

NotEnoughSpaceConfirmContainer.defaultProps = {
	intercomIO: false,
	shouldShowNewTitle: false,
	offerMessage: '',
}

function mapStateToProps(state) {
	return cartSelectors.cartDownloadProductSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: paywallsActions.notEnoughSpaceConfirmCloseSelected,
		confirmUpgrade: paywallsActions.notEnoughSpaceConfirmUpgradeSelected,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NotEnoughSpaceConfirmContainer)
